export default "__VITE_ASSET__CdmgcTh___"